import { post, get, put } from 'services/api';
import { enStatusInvite } from 'interface/invites';
import { API_V4_BASE_URL } from 'settings';
import { toastError, toastSuccess } from 'utils/reduxToast';

export const fetchInvites = () => {
  return get({ url: `/learner/invites`, baseURL: API_V4_BASE_URL }).then((response) => response.data.data);
};

export const acceptAllInvites = () => {
  return post({ url: `/learner/invites/all`, baseURL: API_V4_BASE_URL })
    .then((response) => {
      toastSuccess('Convites aceitos com sucesso!');
      return response.data.data;
    })
    .catch(() => toastError('Não foi possível aceitar os convites no momento. Tente novamente mais tarde!'));
};

export const acceptInvite = (hash: string) => {
  return put({
    url: `/learner/invites/${hash}`,
    baseURL: API_V4_BASE_URL,
    data: { status: enStatusInvite.ACCEPT },
  })
    .then((response) => {
      toastSuccess('Convite aceito com sucesso!');
      return response.data.data;
    })
    .catch(() => toastError('Não foi possível aceitar o convite no momento. Tente novamente mais tarde!'));
};

export const refuseInvite = (hash: string) => {
  return put({
    url: `/learner/invites/${hash}`,
    baseURL: API_V4_BASE_URL,
    data: { status: enStatusInvite.REFUSED },
  })
    .then((response) => {
      toastSuccess('Convite recusado com sucesso!');
      return response.data.data;
    })
    .catch(() => toastError('Não foi possível recusar o convite no momento. Tente novamente mais tarde!'));
};
